
'use client'
import React, { useContext } from 'react'
import cn from 'classnames'
import { useRouter } from 'next/navigation'
import { AuthContext } from '@little-tavern/shared/src/authContext'
import { Menu, Transition } from '@headlessui/react'
import { Fragment, useState } from 'react'
import useDialogLogin from '@little-tavern/shared/src/hook/useDialogLogin'
import { useTranslation } from 'react-i18next'
import Setting from './setting'
import { createPortal } from 'react-dom';
import Link from 'next/link'
import { rigistWeb } from '@/app/module/global'
import Image from 'next/image'
import { CircleUserRound } from 'lucide-react';

const LoginInfo = () => {
  const { t, i18n } = useTranslation()
  const lang = i18n.language
  const auth = useContext(AuthContext);
  const user = auth?.user;
  const dialogLogin = useDialogLogin();
  const router = useRouter();
  const [showSetting, setShowSetting] = useState(false)
  const isVisitor = user?.status === 20 || user?.status === 21;
  const isNotVisitor = !isVisitor;
  // console.log('user?.from', user?.status !== 20 && user?.status !== 21);
  return (<>
    {(!auth?.isTG || process.env.NEXT_PUBLIC_ENV === 'dev') ? <div className='ml-1.5 mr-2 md:mr-4'><div className='relative z-10 flex items-center flex-shrink-0 dark:text-gray-400 text-gray-500'>
      {
        auth?.loginStatus === 1 && isNotVisitor && <div className="flex items-center text-sm">
          <Menu as="div" className="relative inline-block text-left">
            {() => (
              <>
                <div>
                  <Menu.Button className="inline-flex w-full justify-center py-2 text-sm text-white focus:outline-none focus-visible:ring-2">
                    <div className={cn('dark:text-gray-300 text-gray-500 text-right overflow-hidden text-ellipsis whitespace-nowrap')}>
                      {/* {user?.nickname || ''} */}
                      {user?.avatar ? <Image src={user?.avatar} width={24} height={24} className='bg-gray-300 dark:bg-gray-800 rounded-full w-6 h-6' alt={'avatar'} unoptimized /> : <CircleUserRound className='w-6 h-6' strokeWidth={1.5} />}
                    </div>
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="border  dark:border-gray-700 absolute right-0 mt-2 mr-1 w-28 sm:w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white dark:bg-gray-900 shadow-lg ring-1 ring-purple-500 dark:ring-black/5 focus:outline-none">
                    <div className="px-1 py-1 ">

                      <>
                        {/* <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => {
                      setShowSetting(true)
                    }}
                    className={`${
                      active ? 'bg-violet-500 text-white' : ''
                    } group flex w-full items-center rounded-md px-2 py-2 text-sm dark:text-zinc-100`}
                  >{t('app.setting.setting')}</button>
                )}
              </Menu.Item> */}
                        {rigistWeb && <Menu.Item>
                          {({ active }) => (
                            <Link
                              href={`/${lang}/change-password`}
                              className={`${active ? 'bg-violet-500 text-white' : ''
                                } group flex w-full items-center rounded-md px-2 py-2 text-sm dark:text-zinc-100`}
                            >{t('app.login.change_password')}</Link>
                          )}
                        </Menu.Item>}
                        <Menu.Item>
                          {({ active }) => (
                            <button
                              onClick={auth?.logout}
                              className={`${active ? 'bg-violet-500 text-white' : ''
                                } group flex w-full items-center rounded-md px-2 py-2 text-sm dark:text-zinc-100`}
                            >{t('app.common.logout')}</button>
                          )}
                        </Menu.Item>
                      </>
                    </div>
                  </Menu.Items>
                </Transition>
              </>
            )}
          </Menu>
        </div>}
      {(!auth?.isLogin || isVisitor) && <div className='flex items-center text-sm'>
        {isVisitor ? <button className={cn('w-8 h-8 mr-2 rounded-full border border-gray-400 dark:border-gray-500 bg-gray-100 dark:bg-gray-800 text-xs leading-none text-gray-500 dark:text-gray-300 flex flex-shrink-0 items-center justify-center cursor-pointer')} onClick={() => { dialogLogin.show() }}>
          {t('app.visitor.visitor')}
        </button> : <>
          {process.env.NEXT_PUBLIC_OPEN_REGIST === 'true' && <><button className={cn('dark:text-zinc-200 text-gray-400')} onClick={() => { router.push('/register') }}>
            {t('app.common.regist')}
          </button>
            <div className='h-3 mx-1 border-r border-slate-400'></div></>}
          <button className={cn('dark:text-zinc-200 text-gray-400 mr-2')} onClick={() => { dialogLogin.show() }}>
            {t('app.common.login')}
          </button>
        </>}
      </div>
      }
    </div></div> :
      // <Image src={user?.avatar || '/dot.png'} width={24} height={24} className='bg-gray-300 dark:bg-gray-800 rounded-full w-6 h-6' alt={'avatar'} />
      <></>
    }
    {showSetting && createPortal(<Setting auth={auth} onClose={() => { setShowSetting(false) }} />, document.body)}
  </>)
}

export default React.memo(LoginInfo)